import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { onMounted, onUnmounted, ref, watch, computed } from 'vue';
import { VueCookieNext } from 'vue-cookie-next';

import SidebarItem from './components/SidebarItem.vue';
import MobileSidemenuButton from './components/MobileSidemenuButton.vue';
import { PERMISSIONS } from '@/enum';
import { can, useDateTime } from '@/composables';
import { useAuthStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarMenu',
  setup(__props) {

const collapseMenu = ref(false);

const authStore = useAuthStore();
const itemsShowMenu = ref(false);
const dateUtilities = useDateTime();

onMounted(() => {
  if (localStorage.collapseMenu) {
    collapseMenu.value = localStorage.collapseMenu === 'true' ? true : false;
  }
  itemsMenu();
});

const setDatedRoute = (name: string) => {
  const start = dateUtilities.formatDateForApi(dateUtilities.baseMonth());
  const end = dateUtilities.convertInvoiceDateToNextMonth(dateUtilities.baseMonth() as Date, 1, 0, false);
  return `${name}?start_at=${start}&end_at=${end}`;
};

const items = (() => {
  return [
    {
      name: 'Dashboard',
      route: '/',
      icon: 'home',
      style: { width: '18px' },
      permissions: [PERMISSIONS.MENU_DASHBOARD_VIEW],
    },
    {
      name: 'Calendar',
      route: '/calendar',
      icon: 'event',
      style: { width: '18px' },
      permissions: [PERMISSIONS.MENU_CALENDAR_VIEW],
    },
    {
      name: 'Billing',
      route: setDatedRoute('/billing'),
      icon: 'attach_money',
      style: { width: '18px' },
      permissions: [PERMISSIONS.MENU_BILLING_VIEW],
    },
    {
      name: 'Users',
      route: '/users',
      icon: 'supervisor_account',
      style: { width: '18px' },
      permissions: [PERMISSIONS.MENU_USERS_VIEW],
    },
    {
      name: 'Organizations',
      route: '/organizations',
      icon: 'domain',
      style: { width: '16px' },
      permissions: [PERMISSIONS.MENU_ORGANIZATIONS_VIEW],
    },
    {
      name: 'Reports',
      route: setDatedRoute('/reports'),
      icon: 'bar_chart',
      style: { width: '14px' },
      permissions: [PERMISSIONS.MENU_REPORTS_VIEW],
    },
  ];
})();

watch(
  () => authStore.permissionGlobal,
  () => {
    itemsMenu();
  },
);

const tenantGuest = ref(false);

const itemsMenu = () => {
  tenantGuest.value = VueCookieNext.getCookie('access_token_tenant');
  itemsShowMenu.value = items.filter((item) => {
    if (tenantGuest.value && tenantGuest.value.guest_tenant.master !== 1)
      return can(item.permissions || []) && item.name !== 'Billing';
    else return can(item.permissions || []);
  });
};

const toggleCollapse = () => {
  collapseMenu.value = !collapseMenu.value;
  localStorage.collapseMenu = collapseMenu.value ? 'true' : 'false';
};

const displayMobileMenu = ref(false);

const toggleMobileMenu = () => {
  displayMobileMenu.value = !displayMobileMenu.value;
  window.addEventListener('resize', checkWindowWidth);
};

const checkWindowWidth = () => {
  if (window.innerWidth > 480) {
    displayMobileMenu.value = false;
    window.removeEventListener('resize', checkWindowWidth);
  }
};

const hasTenantGuest = computed(() => !!tenantGuest.value);

onUnmounted(() => window.removeEventListener('resize', checkWindowWidth));

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MobileSidemenuButton, {
      "viewing-tenant": hasTenantGuest.value,
      onClick: toggleMobileMenu
    }, null, 8, ["viewing-tenant"]),
    _createElementVNode("div", {
      class: _normalizeClass([{
      collapsed: collapseMenu.value && !displayMobileMenu.value,
      banner: _unref(authStore).isSwitchTenant,
      mobile: displayMobileMenu.value,
    }, "sidebar"])
    }, [
      (itemsShowMenu.value && itemsShowMenu.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsShowMenu.value, (item) => {
              return (_openBlock(), _createBlock(SidebarItem, {
                key: item.icon,
                name: item.name,
                icon: item.icon,
                mobile: displayMobileMenu.value,
                route: item.route,
                style: _normalizeStyle(item.style),
                collapse: collapseMenu.value && !displayMobileMenu.value
              }, null, 8, ["name", "icon", "mobile", "route", "style", "collapse"]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_Skeleton, {
              width: "100%",
              height: "2rem",
              "border-radius": "2rem",
              class: "mb-2"
            }),
            _createVNode(_component_Skeleton, {
              width: "100%",
              height: "2rem",
              "border-radius": "2rem",
              class: "mb-2"
            }),
            _createVNode(_component_Skeleton, {
              width: "100%",
              height: "2rem",
              "border-radius": "2rem",
              class: "mb-2"
            }),
            _createVNode(_component_Skeleton, {
              width: "100%",
              height: "2rem",
              "border-radius": "2rem",
              class: "mb-2"
            }),
            _createVNode(_component_Skeleton, {
              width: "100%",
              height: "2rem",
              "border-radius": "2rem",
              class: "mb-2"
            })
          ])),
      _createVNode(_component_Button, {
        class: "collapse-button",
        onClick: toggleCollapse
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", { class: "material-icons collapse-button__chevron-icon_left" }, "chevron_left", -1),
          _createElementVNode("span", { class: "material-icons collapse-button__chevron-icon_right" }, "chevron_right", -1),
          _createElementVNode("p", null, "Collapse", -1)
        ]))]),
        _: 1
      })
    ], 2)
  ], 64))
}
}

})